'use client'
import { MKTU_CLASS_CATEGORY_TITLE } from '@/models/Mktu'
import { MktuClassWord } from '@/services/Api/generated'
import { MktuClassStore } from '@/store/Mktu/MktuClass'
import classNames from 'classnames'
import { observer } from 'mobx-react-lite'
import { FunctionComponent, useCallback } from 'react'
import { Word } from '../Word'
import styles from './ClassCard.module.scss'

const DEFAULT_DISPLAY_QUANTITY = 4

type ClassCardProps = {
  mktuClass: MktuClassStore
  onClick: (classNumber: MktuClassStore['uuid']) => void
  className?: string
  isReadonly?: boolean
  selectedWordsTitle?: string
  selectAnotherText?: string
  isWithoutDescription?: boolean
  isFullDescription?: boolean
}
export const ClassCard: FunctionComponent<ClassCardProps> = observer(
  ({
    mktuClass,
    onClick,
    className,
    isReadonly,
    selectedWordsTitle,
    selectAnotherText,
    isWithoutDescription = false,
    isFullDescription = false,
  }) => {
    const click = useCallback(() => {
      onClick(mktuClass.uuid)
    }, [onClick, mktuClass])

    const deleteWord = useCallback(
      (deleteName: MktuClassWord['word']) => {
        const newSelectedWordNames = mktuClass.selectedWordsNames.filter(
          (name) => name !== deleteName
        )
        mktuClass.setSelectedWordsNames(newSelectedWordNames)
      },
      [mktuClass]
    )

    return (
      <div className={classNames(styles.container, className)}>
        <div className={styles.header}>
          <div className={styles.title}>Класс {mktuClass.number}</div>
          <div className={styles.type}>
            {MKTU_CLASS_CATEGORY_TITLE[mktuClass.type] ?? ''}
          </div>
        </div>
        {!isWithoutDescription ? (
          <div
            className={classNames({
              [styles.description]: true,
              [styles.isFullDescription]: isFullDescription,
            })}
          >
            {mktuClass.description}
          </div>
        ) : null}
        {mktuClass.selectedWordsNames.length !== 0 ? (
          <div>
            <div className={styles.selectedWordsTitle}>
              {selectedWordsTitle ?? 'Выбранные позиции'}
              {!isReadonly ? (
                <button
                  type="button"
                  className={styles.selectAnotherButton}
                  onClick={click}
                >
                  {selectAnotherText ?? 'Выбрать другие'}
                </button>
              ) : null}
            </div>
            <div className={styles.words}>
              {mktuClass.selectedWordsNames
                .slice(0, DEFAULT_DISPLAY_QUANTITY)
                .map((name) => (
                  <div key={name}>
                    <Word
                      id={name}
                      name={name}
                      onClick={deleteWord}
                      isReadonly={isReadonly}
                      isDeletable={!isReadonly}
                      isSelected
                    />
                  </div>
                ))}
              {mktuClass.selectedWordsNames.length >
              DEFAULT_DISPLAY_QUANTITY ? (
                <button className={styles.hiddenWordsText} onClick={click}>
                  еще{' '}
                  {mktuClass.selectedWordsNames.length -
                    DEFAULT_DISPLAY_QUANTITY}
                </button>
              ) : null}
            </div>
          </div>
        ) : null}
        {mktuClass.selectedWordsNames.length === 0 ? (
          <button type="button" className={styles.selectButton} onClick={click}>
            Выбрать позиции для регистрации
          </button>
        ) : null}
      </div>
    )
  }
)
